import classNames from "classnames";
import { createPortal } from "react-dom";
import { ModalContainer } from "~/common/ModalContainer";
import { ProfileImage } from "./ProfileImage";

export function ProfileModal({
  name,
  imageUrl,
  title,
  bio,
  show,
  onClose,
}: {
  name: string;
  imageUrl: string;
  title: string;
  bio: string;
  show: boolean;
  onClose?: () => void;
}) {
  const handleClose = () => {
    if (onClose) onClose();
  };

  if (!show) return null;

  const el = document.querySelector("#cn-profile-modal");
  console.log("found el ", el);

  return createPortal(
    <ModalContainer bgColor={"tw:bg-[#355ffe]/50"} onClose={handleClose}>
      <div className="tw:w-full tw:h-full tw:overflow-auto tw:rounded-xl tw:bg-white tw:max-w-[588px] tw:max-h-[600px] tw:p-[24px] tw:pb-[56px]">
        <div className="tw:flex tw:flex-row tw:justify-between tw:w-full">
          <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center tw:w-full">
            <div className="tw:min-w-[200px]">
              <ProfileImage title={title} imageUrl={imageUrl} />
            </div>

            <div
              className={classNames(
                "tw:flex tw:flex-col tw:justify-center tw:gap-4 tw:py-4 tw:w-full",
                "tw:justify-center tw:h-full",
              )}
            >
              <div
                className={classNames(
                  "tw:tracking-tight tw:font-[600]",
                  "tw:text-[1.5rem]",
                  "tw:w-full",
                )}
              >
                {name ?? ""}
              </div>
              <div className="tw:font-[400] tw:text-base tw:leading-normal">
                {title ?? ""}
              </div>
            </div>
            <div className="tw:flex tw:flex-col tw:justify-start tw:items-start tw:h-full tw:min-h-full tw:cursor-pointer">
              <div
                className="tw:bg-[url(./assets/images/icons/atom_icon_close_black@2x.svg)] tw:bg-contain tw:bg-no-repeat tw:w-4 tw:h-4"
                onClick={handleClose}
              />
            </div>
          </div>
        </div>
        <div className="tw:font-[400] tw:text-base tw:leading-normal tw:mt-[24px] tw:mb-[40px]">
          {bio ?? ""}
        </div>
      </div>
    </ModalContainer>,
    el!,
  );
}
